export const SAMPLES_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "reporterId", label: "ID do Relator" },
  { id: "individualId", label: "Indivíduo ID" },
  { id: "anonymousIndividualTaxonomicGroupId", label: "Grupo Taxonômico ID" },
  { id: "anonymousIndividualGender", label: "Sexo" },
  { id: "type", label: "Tipo" },
  { id: "sampleDate", label: "Data Coleta" },
  { id: "destination", label: "Destino" },
  { id: "latitude", label: "Latitude" },
  { id: "longitude", label: "Longitude" },
  { id: "visitId", label: "Visita ID" },
  { id: "attachmentsCount", label: "Anexos" },
  { id: "observations", label: "Observações" },
  { id: "lastEditor", label: "Último Editor" },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];
